import { useQuery } from '@tanstack/react-query';
import { ApiResponse, SiteMessage } from '../../common/types';

export const siteMessageKeys = {
  all: ['siteMessage'] as const,
};

// Read-only and public: the banner shows on the login page too, before any
// token exists, so this uses bare fetch — NOT axiosInstance, whose interceptor
// force-signs-out when there is no session. Set by super-admins via the
// separate admin panel; this app only displays it. Poll so it appears/clears
// without a reload.
export const useSiteMessage = () =>
  useQuery({
    queryKey: siteMessageKeys.all,
    queryFn: async (): Promise<SiteMessage> => {
      const res = await fetch('/api/site-message/');
      const body = (await res.json()) as ApiResponse<SiteMessage>;
      if (!body.success) {
        throw new Error(body.error.message);
      }
      return body.data;
    },
    refetchInterval: 60_000,
    // A status banner must reflect the DB promptly, so always refetch on mount
    // rather than trusting the global 5-min staleTime / persisted cache.
    staleTime: 0,
    retry: 1,
  });
